export default (a, b) => (a.priority <= b.priority ? -1 : 1)
